import { gbp } from "@/lib/api";
import { BookingDialog } from "@/components/BookingDialog";
import { Button } from "@/components/ui/button";
import { Star, MapPin } from "lucide-react";

export const HotelCard = ({ h }) => (
  <div data-testid={`hotel-card-${h.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(11,60,93,0.12)] transition-all duration-300">
    <div className="relative h-48">
      <img src={h.image} alt={h.name} className="w-full h-full object-cover" />
      <span className="absolute top-3 left-3 bg-white/95 rounded-full px-2.5 py-1 text-xs font-bold text-[#0B3C5D] flex items-center gap-1">
        <Star className="w-3.5 h-3.5 fill-[#FF6B35] text-[#FF6B35]" /> {h.rating}
      </span>
      <span className="absolute top-3 right-3 bg-[#0B3C5D] text-white rounded-full px-2.5 py-1 text-xs font-semibold">{h.stars}★</span>
    </div>
    <div className="p-5">
      <h3 className="font-display font-semibold text-slate-900 leading-tight line-clamp-1">{h.name}</h3>
      <p className="text-xs text-slate-400 flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" /> {h.city}, {h.country}</p>
      <div className="flex flex-wrap gap-1.5 mt-3">
        {(h.amenities || []).slice(0, 3).map((a) => (
          <span key={a} className="text-[10px] bg-slate-100 text-slate-600 rounded-full px-2 py-0.5">{a}</span>
        ))}
      </div>
      <div className="flex items-end justify-between mt-4 pt-4 border-t border-slate-100">
        <div><p className="text-[11px] text-slate-400">per night</p><p className="font-display text-2xl font-bold text-[#0B3C5D]">{gbp(h.price)}</p></div>
        <BookingDialog productType="hotel" item={h} unitPrice={h.price}
          trigger={<Button data-testid={`book-hotel-${h.id}`} className="rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold">Book Now</Button>} />
      </div>
    </div>
  </div>
);
